export default __webpack_public_path__ + "23918380ad5bd237caf3ffc8812c440e.svg";